(function () {
  // Guard against the script being included more than once on the page.
  if (window.__vwUrlWatcherInit) return;
  window.__vwUrlWatcherInit = true;
  // Seed with the current path so the INITIAL page load is not treated as a URL
  // change (Videowise already initializes the widget natively on load). We only
  // re-init when the URL actually changes (e.g. variant switch).
  let lastProcessedUrl = window.location.pathname;
  function fetchAndUpdateProduct(handle) {
    const jsonUrl = `/products/${handle}.json`;
    fetch(jsonUrl)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        if (!data.product || !data.product.id) return;
        const newProductId = data.product.id;
        if (window.__st) {
          window.__st.rid = newProductId;
          window.__st.pageurl = window.location.href;
        }
        if (typeof videowiseBulkTrigger === 'function') {
          const shopifyBlocks = document.querySelectorAll('[class*="videowise_video_commerce"], [id*="reeview-app-widget"]');
          shopifyBlocks.forEach(block => {
            const clone = block.cloneNode(false);
            if (clone.hasAttribute('data-product-id')) {
              clone.setAttribute('data-product-id', newProductId);
            }
            clone.innerHTML = '';
            block.parentNode.replaceChild(clone, block);
          });
          setTimeout(() => {
            window.videowiseIdsLoaded = [];
            if (typeof initVideowise === 'function') {
              try { initVideowise();console.log('duplicate....') } catch (e) { }
            }
            window.videowiseBulkTrigger();
          }, 400);
        }
      })
      .catch(err => console.error(':x: Update error:', err));
  }
  const pushState = history.pushState;
  history.pushState = function () {
    pushState.apply(history, arguments);
    handleUrlChange();
  };
  const replaceState = history.replaceState;
  history.replaceState = function () {
    replaceState.apply(history, arguments);
    handleUrlChange();
  };
  window.addEventListener("popstate", handleUrlChange);
  function handleUrlChange() {
    const currentUrl = window.location.pathname;
    if (currentUrl === lastProcessedUrl) return;
    lastProcessedUrl = currentUrl;
    const handle = currentUrl.split("/").pop();
    if (handle && currentUrl.includes('/products/')) {
      fetchAndUpdateProduct(handle);
    }
  }
})();